interface MyObject {
  [key: string]: string;
}

const userProfile = localStorage.getItem('USER_PROFILE');
const loggedInUser_ids = userProfile
  ? JSON.parse(userProfile).unique_ids
  : null;

let iffl_base_url = ''; // declare outside

if (loggedInUser_ids != null && loggedInUser_ids !== 'undefined') {
  const iiflUniquId = loggedInUser_ids.filter(
    (data: any) => data.exchange === 'iifl'
  );

  if (iiflUniquId.length > 0) {
    iffl_base_url =
      'https://tradingdeskstocks.cryptocentric.co/api/v1.0/trading/iifl/getHistoricalData?uniqueid=' +
      iiflUniquId[0]._id;
  }
}

let history: MyObject = { key: 'value' };

// In-memory cache for bars
const barsCache: Record<string, any[]> = {};
const lastFetchedTime: Record<string, number> = {};

function getRequest(url: string): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.onload = function () {
      this.status === 200
        ? resolve(this.response)
        : reject(new Error(this.statusText));
    };
    request.onerror = function () {
      reject(new Error('XMLHttpRequest Error: ' + this.statusText));
    };
    request.open('GET', url);
    request.send();
  });
}

function getIIFLscriptCode(url: string): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.onload = function () {
      this.status === 200
        ? resolve(this.response)
        : reject(new Error(this.statusText));
    };
    request.onerror = function () {
      reject(new Error('XMLHttpRequest Error: ' + this.statusText));
    };
    request.open('GET', url);
    request.send();
  });
}

// Periodically update `history` value
function refreshHistoryData() {
  history = {
    key: 'value_' + new Date().toISOString(),
  };
}
setInterval(refreshHistoryData, 2000);

export default {
  get history() {
    return history;
  },

  getBars: async (
    symbolInfo: any,
    resolution: string,
    from: any,
    to: any,
    first: any,
    limit: any,
    brokerValue: number
  ) => {
    const split_symbol = symbolInfo.name;
    const today = new Date();
    const today_ = today.toISOString().slice(0, 10);

    const formatDate = (date: Date) => date.toISOString().slice(0, 10);
    const subtractDays = (days: number) => {
      const d = new Date(today);
      d.setDate(today.getDate() - days);
      return formatDate(d);
    };
    const subtractMonths = (months: number) => {
      const d = new Date(today);
      d.setMonth(today.getMonth() - months);
      return formatDate(d);
    };
    const subtractYears = (years: number) => {
      const d = new Date(today);
      d.setFullYear(today.getFullYear() - years);
      return formatDate(d);
    };

    const aggResolutions = ['120', '180', '240', '480'];
    const cacheKey = `${split_symbol}_${resolution}`;
    const now = Date.now();

    // Return cached bars if available within last 60s
    if (
      barsCache[cacheKey] &&
      lastFetchedTime[cacheKey] &&
      now - lastFetchedTime[cacheKey] < 2000
    ) {
      return barsCache[cacheKey];
    }

    let fetchInterval = resolution;
    let fromDate_ = subtractDays(10);
    let interval_ = '';

    // Resolution mapping logic
    switch (resolution) {
      case '1':
      case '3':
      case '5':
        if (brokerValue === 1) {
          interval_ = `Interval=${resolution}m`;
        }
        if (brokerValue === 3) {
          interval_ = `interval=${resolution}m`;
        }
        fromDate_ = subtractDays(15);
        break;
      case '15':
      case '30':
      case '45':
        if (brokerValue === 1) {
          interval_ = `Interval=${resolution}m`;
          fromDate_ = subtractMonths(5);
        }
        if (brokerValue === 3) {
          interval_ = `interval=${resolution}m`;
        }
        break;
      case '60':
        if (brokerValue === 1) {
          interval_ = `Interval=${resolution}m`;
          fromDate_ = subtractMonths(5);
        }
        if (brokerValue === 3) {
          interval_ = `interval=1h`;
        }

        break;
      case '120':
      case '180':
      case '240':
      case '480':
        fetchInterval = '5';
        if (brokerValue === 1) {
          interval_ = `Interval=${fetchInterval}m`;
          fromDate_ = subtractMonths(2);
        }
        if (brokerValue === 3) {
          interval_ = `interval=${fetchInterval}m`;
        }
        break;
      case 'D':
      case '1D':
        if (brokerValue === 1) {
          interval_ = 'Interval=1d';
          fromDate_ = subtractYears(5);
        }
        if (brokerValue === 3) {
          interval_ = 'interval=1d';
        }
        break;
      default:
        if (brokerValue === 1) {
          interval_ = 'Interval=1d';
          fromDate_ = subtractYears(5);
        }
        if (brokerValue === 3) {
          interval_ = 'interval=1d';
        }
        break;
    }

    try {
      if (brokerValue === 1) {
        const symbolDetailsResponse = await getIIFLscriptCode(
          `https://tradingdeskstocks.cryptocentric.co/api/v1.0/trading/iifl/getSymbolDetails?symbol=${split_symbol}`
        );
        const symbolDetails = JSON.parse(symbolDetailsResponse);
        if (symbolDetails.status !== 'success') return [];

        const stockData = symbolDetails.data.symbolData;

        const candlesResponse = await getRequest(
          `${iffl_base_url}&Exch=${stockData.Exch}&ExchType=${stockData.ExchType}&ScripCode=${stockData.Scripcode}&${interval_}&FromDate=${fromDate_}&EndDate=${today_}`
        );

        const candleData = JSON.parse(candlesResponse);
        if (candleData.status !== 'success') return [];

        const rawData = candleData.data.candleData;

        let bars: any[];

        if (aggResolutions.includes(resolution)) {
          bars = aggregateBars(rawData, parseInt(resolution));
        } else {
          bars = rawData.map((el: any) => ({
            time: new Date(el[0]).getTime(),
            open: el[1],
            high: el[2],
            low: el[3],
            close: el[4],
            volume: el[5],
          }));
        }

        // Cache the result
        barsCache[cacheKey] = bars;
        lastFetchedTime[cacheKey] = now;

        return bars;
      } else if (brokerValue === 3) {
        const candlesResponse = await getRequest(
          `http://localhost:5000/ohlc?symbol=NIFTY_50&exchange=nse&${interval_}&bars=3000`
        );

        const candleData = JSON.parse(candlesResponse);
        if (!candleData) return [];

        const rawData = candleData.data;

        let bars: any[];

        if (aggResolutions.includes(resolution)) {
          bars = aggregateBars(rawData, parseInt(resolution));
        } else {
          bars = rawData.map((el: any) => ({
            time: new Date(el.datetime).getTime(),
            open: el.open,
            high: el.high,
            low: el.low,
            close: el.close,
            volume: el.volume,
          }));
        }

        // Cache the result
        // barsCache[cacheKey] = bars;
        // lastFetchedTime[cacheKey] = now;
        return bars;
      } else {
        console.warn('Broker not supported yet:', brokerValue);
        return [];
      }
    } catch (error) {
      console.error('getBars error:', error);
      return [];
    }
  },
};

function aggregateBars(rawData: any[], resolutionMinutes: number): any[] {
  const millisInOneBar = resolutionMinutes * 60 * 1000;
  const groupedBars: any[] = [];

  let currentGroup: any[] = [];
  let currentGroupStart: number | null = null;

  for (const el of rawData) {
    const timestamp = new Date(el[0]).getTime();
    const groupStart = Math.floor(timestamp / millisInOneBar) * millisInOneBar;

    if (currentGroupStart === null) {
      currentGroupStart = groupStart;
    }

    if (groupStart === currentGroupStart) {
      currentGroup.push(el);
    } else {
      if (currentGroup.length) {
        groupedBars.push(buildCandle(currentGroup, currentGroupStart));
      }
      currentGroup = [el];
      currentGroupStart = groupStart;
    }
  }

  if (currentGroup.length) {
    groupedBars.push(buildCandle(currentGroup, currentGroupStart!));
  }

  return groupedBars;
}

function buildCandle(group: any[], groupStartTime: number): any {
  return {
    time: groupStartTime, // Already in correct UTC ms format
    open: group[0][1],
    high: Math.max(...group.map((el) => el[2])),
    low: Math.min(...group.map((el) => el[3])),
    close: group[group.length - 1][4],
    volume: group.reduce((sum, el) => sum + el[5], 0),
  };
}
